(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart-group.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (100 / runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"columns")),"length"));
frame.set("groupWidthPerc", t_1, true);
if(frame.topLevel) {
context.setVariable("groupWidthPerc", t_1);
}
if(frame.topLevel) {
context.addExport("groupWidthPerc", t_1);
}
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "groupWidthPerc") > runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"column_max_width_perc")) {
output += " ";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"column_max_width_perc");
frame.set("groupWidthPerc", t_2, true);
if(frame.topLevel) {
context.setVariable("groupWidthPerc", t_2);
}
if(frame.topLevel) {
context.addExport("groupWidthPerc", t_2);
}
output += " ";
;
}
output += " ";
var t_3;
t_3 = (runtime.contextOrFrameLookup(context, frame, "groupWidthPerc") * runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth")) / 100;
frame.set("groupWidthValue", t_3, true);
if(frame.topLevel) {
context.setVariable("groupWidthValue", t_3);
}
if(frame.topLevel) {
context.addExport("groupWidthValue", t_3);
}
output += " ";
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"group_top_offset_perc") * runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight");
frame.set("topOffset", t_4, true);
if(frame.topLevel) {
context.setVariable("topOffset", t_4);
}
if(frame.topLevel) {
context.addExport("topOffset", t_4);
}
output += " ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight");
frame.set("groupHeightValue", t_5, true);
if(frame.topLevel) {
context.setVariable("groupHeightValue", t_5);
}
if(frame.topLevel) {
context.addExport("groupHeightValue", t_5);
}
output += " ";
var t_6;
t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight") - runtime.contextOrFrameLookup(context, frame, "topOffset");
frame.set("innerGroupHeightValue", t_6, true);
if(frame.topLevel) {
context.setVariable("innerGroupHeightValue", t_6);
}
if(frame.topLevel) {
context.addExport("innerGroupHeightValue", t_6);
}
output += " ";
var t_7;
t_7 = 1;
frame.set("yAxesStep", t_7, true);
if(frame.topLevel) {
context.setVariable("yAxesStep", t_7);
}
if(frame.topLevel) {
context.addExport("yAxesStep", t_7);
}
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axes_step")) {
output += " ";
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axes_step");
frame.set("yAxesStep", t_8, true);
if(frame.topLevel) {
context.setVariable("yAxesStep", t_8);
}
if(frame.topLevel) {
context.addExport("yAxesStep", t_8);
}
output += " ";
;
}
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"start_from_zero")) {
output += " ";
var t_9;
t_9 = runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - runtime.contextOrFrameLookup(context, frame, "yAxesStep");
frame.set("innerGroupHeightValue", t_9, true);
if(frame.topLevel) {
context.setVariable("innerGroupHeightValue", t_9);
}
if(frame.topLevel) {
context.addExport("innerGroupHeightValue", t_9);
}
output += " ";
;
}
output += " <svg height=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupHeightValue"), env.opts.autoescape);
output += "\" class=\"chart-group\" data-group-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupIndex"), env.opts.autoescape);
output += "\" width=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthPerc"), env.opts.autoescape);
output += "%\" x=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupIndex") * runtime.contextOrFrameLookup(context, frame, "groupWidthPerc"), env.opts.autoescape);
output += "%\" y=\"0\"> <path fill=\"transparent\" class=\"chart-group-backlayer\" d=\"M 0,0 v ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupHeightValue"), env.opts.autoescape);
output += " h ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthValue"), env.opts.autoescape);
output += " v -";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupHeightValue"), env.opts.autoescape);
output += " z\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "group")),"style")) {
output += " style=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "group")),"style"), env.opts.autoescape);
output += "\" ";
;
}
output += " ></path> ";
if(runtime.contextOrFrameLookup(context, frame, "groupIndex") > 0) {
output += " <line class=\"group-borders left-border\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupHeightValue"), env.opts.autoescape);
output += "\"></line> ";
;
}
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "groupIndex") < (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"columns")),"length") - 1)) {
output += " <line class=\"group-borders right-border\" x1=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthValue"), env.opts.autoescape);
output += "\" y1=\"0\" x2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthValue"), env.opts.autoescape);
output += "\" y2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupHeightValue"), env.opts.autoescape);
output += "\"></line> ";
;
}
output += " <line class=\"group-borders top-border\" x1=\"";
output += runtime.suppressValue(0, env.opts.autoescape);
output += "\" y1=\"0\" x2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthValue"), env.opts.autoescape);
output += "\" y2=\"0\"></line> ";
var t_10;
t_10 = runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue");
frame.set("svgHeight", t_10, true);
if(frame.topLevel) {
context.setVariable("svgHeight", t_10);
}
if(frame.topLevel) {
context.addExport("svgHeight", t_10);
}
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"start_from_zero")) {
output += " ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") + (runtime.contextOrFrameLookup(context, frame, "yAxesStep") / 2);
frame.set("svgHeight", t_11, true);
if(frame.topLevel) {
context.setVariable("svgHeight", t_11);
}
if(frame.topLevel) {
context.addExport("svgHeight", t_11);
}
output += " ";
;
}
output += " <svg x=\"0\" width=\"100%\" y=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "topOffset"), env.opts.autoescape);
output += "\" height=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "svgHeight"), env.opts.autoescape);
output += "\"> ";
frame = frame.push();
var t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),"primary")),"values");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("xLineValue", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += " ";
var t_16;
t_16 = (runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((t_15 / runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),"primary")),"maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue")));
frame.set("yValue", t_16, true);
if(frame.topLevel) {
context.setVariable("yValue", t_16);
}
if(frame.topLevel) {
context.addExport("yValue", t_16);
}
output += " <line class=\"x-line ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),"primary")),"values")),"length") - 1)) {
output += "last-child";
;
}
output += "\" x1=\"";
output += runtime.suppressValue(0, env.opts.autoescape);
output += "\" y1=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yValue"), env.opts.autoescape);
output += "\" x2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "groupWidthValue"), env.opts.autoescape);
output += "\" y2=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yValue"), env.opts.autoescape);
output += "\"></line> ";
;
}
}
frame = frame.pop();
output += " ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"data");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("dataGroup", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += " ";
if(runtime.memberLookup((t_20),"type") == "bars") {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/chart-group-bars.njk", false, "../hmodules/components/h-charts/partials/chart-group.njk", false, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
callback(null,t_21);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
callback(null,t_23);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
});
}
output += " ";
if(runtime.memberLookup((t_20),"type") == "lines") {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/chart-group-lines.njk", false, "../hmodules/components/h-charts/partials/chart-group.njk", false, function(t_26,t_25) {
if(t_26) { cb(t_26); return; }
callback(null,t_25);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_28,t_27) {
if(t_28) { cb(t_28); return; }
callback(null,t_27);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
});
}
output += " ";
;
}
}
frame = frame.pop();
output += " </svg> </svg>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
